module.exports = __webpack_public_path__ + "img/Icon - Wrong Answer.942c1d38.svg";